import { FillImage } from "components/images";
import { Section, sectionSpacingY } from "components/section";
import React from "react";
import { Diptych, DiptychColumn } from "ui/diptych";
import { TextTitle } from "ui/text";
import diptychImage1 from "../../../../public/assets/platform/event-collection/workflow-diptych-1.png";
import diptychImage2 from "../../../../public/assets/platform/event-collection/workflow-diptych-2.png";
import diptychImage3 from "../../../../public/assets/platform/event-collection/workflow-diptych-3.png";

export function WorkflowFeatures() {
  return (
    <Section theme="dark" bg="new.gray.950" themeBgColor="new.gray.950" py="0" pb={sectionSpacingY}>
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title="Have full control of your workflows"
        mb={{ base: "biggest", md: "huge" }}
      />

      <DiptychColumn>
        <Diptych
          theme="dark"
          size="md"
          direction="right"
          media={
            <FillImage
              src={diptychImage1}
              alt='An illustration showing an example of three "Git history" events. The first is for "Pull request (via Hightouch)" with a button labeled "Accept", the second is for "Merged (via Git repo)" with a button labeled "Revert", and the third is for "Merged (via Hightouch)" with a button labeled "Revert".'
            />
          }
          title="Manage changes with version control"
          description="Git sync management makes it easy to manage your tracking plan alongside your code so that you can stay up to date and catch regressions before they reach production."
        />

        <Diptych
          theme="dark"
          size="md"
          direction="right"
          media={
            <FillImage
              src={diptychImage2}
              alt='An illustration showing an abstract example of events in a debugger log, such as "identify", "Order Completed", and "page". To the side, there is an example of JSON data for the debug event, including "channel" and "context" fields.'
            />
          }
          title="Observe and troubleshoot your events"
          description="Get deep event-level observability and customizable alerting for swift issue diagnosis so you can triage quickly."
        />

        <Diptych
          theme="dark"
          size="md"
          direction="right"
          media={
            <FillImage
              src={diptychImage3}
              alt="An illustration showing a code snippet of a sample JavaScript function that can be written to perform custom transformation on an array of events."
            />
          }
          title="Clean, transform, and enrich your event data using code"
          description="Use simple, modern JavaScript to modify, validate, enrich, or filter events with custom logic before syncing to destinations."
        />
      </DiptychColumn>
    </Section>
  );
}
